import React from "react";
import "./packagesDesktop.scss";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { Risk, RisksId } from "../../../../helpers/risk";
import { PackageId } from "../../../../helpers/package";
import { CalculationService } from "../../../../services/services/calculationService";
import PackagesContent from "../../../../helpers/packagesContent";
import { PolicyStore } from "../../../../stores/policyStore";
import { ReplenishmentHistoryStore } from "../../../../stores/replenishmentHistoryStore";

interface PackagesDesktopProps {
    calculateStore?: CalculateStore;
    calculationService?: CalculationService;
    replenishmentHistoryStore?: ReplenishmentHistoryStore;
    policyStore?: PolicyStore;
    refreshPackage: (packageId: PackageId) => void;
    disabledButtons: boolean;
    setErrorMessage: (errorMessage: string) => void;
}

interface PackagesDesktopState {
    displayContextHelpForRisk: RisksId[];
}

@inject("calculateStore", "calculationService", "policyStore", "replenishmentHistoryStore")
@observer
export default class PackagesDesktop extends React.Component<PackagesDesktopProps, PackagesDesktopState> {
    private packagesContent: PackagesContent;

    constructor(props: any) {
        super(props);

        this.state = {
            displayContextHelpForRisk: []
        };

        this.packagesContent = new PackagesContent(this.props.calculateStore!, this.props.calculationService!,
            this.props.setErrorMessage, this.props.refreshPackage, this.infoIconOnClick, this, this.props.policyStore!, this.props.replenishmentHistoryStore!);
    }

    public render() {
        const calculateStore = this.props.calculateStore!;
        const packages = calculateStore.packages;
        const disabled = !calculateStore.propertyInsurance;

        return (
            <div className={`packages-desktop ${disabled ? "disabled" : ""}`}>
                {packages.has(PackageId.mini) && packages.has(PackageId.midi) && packages.has(PackageId.maxi) && (
                    <>
                        <div className="packages-content">
                            {this.renderPackages()}
                        </div>

                        {this.packagesContent.renderAmountInsuranceMessage()}
                    </>
                )}
            </div>
        );
    }

    private renderPackages(): JSX.Element[] {
        const packagesContainer: JSX.Element[] = [];

        packagesContainer.push(this.renderEmptyDiv('top'));
        packagesContainer.push(...this.packagesContent.renderSelectButtons(this.props.disabledButtons, 'top'));
        packagesContainer.push(this.renderInsuranceHeader());
        packagesContainer.push(...this.packagesContent.renderHeaders());
        packagesContainer.push(...this.renderBody());
        packagesContainer.push(this.renderEmptyDiv('bottom'));
        packagesContainer.push(...this.packagesContent.renderSelectButtons(this.props.disabledButtons, 'bottom'));

        return packagesContainer;
    }

    private renderInsuranceHeader(): JSX.Element {
        return (
            <div key="insurance-header" className="header insurance-header">
                Przedmiot i zakres ubezpieczenia
            </div>
        );
    }

    private renderBody(): JSX.Element[] {
        const calculateStore = this.props.calculateStore!;
        const cellContainer: JSX.Element[] = [];

        Risk.getRisksListInPackage(calculateStore!.estate.propertyType!).forEach((riskId: RisksId) => {
            cellContainer.push(this.packagesContent.renderRisksDisplayName(riskId));
            cellContainer.push(...this.packagesContent.renderAllValuesForRisk(riskId, this.props.disabledButtons));

            if (!this.state.displayContextHelpForRisk.includes(riskId)) {
                return;
            }

            cellContainer.push(...this.renderContextHelps(riskId));
        });

        return cellContainer;
    }

    private renderContextHelps(riskId: RisksId): JSX.Element[] {
        const contextHelpDescription = Risk.getContextHelpDescription(this.props.calculateStore!.estate.propertyType!);
        const cellContainer: JSX.Element[] = [];

        for (const contextHelpDescriptionObject in contextHelpDescription) {
            if (!contextHelpDescription.hasOwnProperty(contextHelpDescriptionObject)) {
                continue;
            }

            if (contextHelpDescriptionObject === riskId) {
                // @ts-ignore
                const riskContextHelps = contextHelpDescription[RisksId[riskId]];
                let oddRow = true;

                for (const contextHelpId in riskContextHelps) {
                    if (!riskContextHelps.hasOwnProperty(contextHelpId)) {
                        continue;
                    }

                    oddRow = !oddRow;
                    cellContainer.push(this.packagesContent.renderContextHelpDisplayName(riskId, riskContextHelps, contextHelpId, oddRow));
                    cellContainer.push(...this.packagesContent.renderAllValuesForContextHelp(riskId, contextHelpId, oddRow));
                }
            }
        }

        return cellContainer;
    }

    private renderEmptyDiv(position: string) {
        // add empty div, because we have 3 packages and grid have 4 columns

        return (
            <div key={`empty-div-${position}`} />
        );
    }

    private infoIconOnClick(riskId: RisksId) {
        const displayContextHelp = this.state.displayContextHelpForRisk.indexOf(riskId);

        if (displayContextHelp === -1) {
            this.setState({ displayContextHelpForRisk: [...this.state.displayContextHelpForRisk, riskId] });
        } else {
            this.state.displayContextHelpForRisk.splice(displayContextHelp, 1);
            this.setState({ displayContextHelpForRisk: this.state.displayContextHelpForRisk });
        }
    }
}
